import axios, { AxiosRequestConfig } from 'axios';
import { useMemo } from 'react';
import useInertiaData from './useInertiaData';

const useApi = () => {
    const { csrf_token } = useInertiaData();

    const api = useMemo(() => {
        const instance = axios.create({
            headers: {
                'X-CSRFToken': csrf_token || '',
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        });

        return {
            get: <T = any>(url: string, config?: AxiosRequestConfig) =>
                instance.get<T>(url, config),
            post: <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
                instance.post<T>(url, data, config),
            put: <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
                instance.put<T>(url, data, config),
            patch: <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
                instance.patch<T>(url, data, config),
            delete: <T = any>(url: string, config?: AxiosRequestConfig) =>
                instance.delete<T>(url, config),
        };
    }, [csrf_token]);

    return api;
};

export default useApi;
